import React from 'react';
import { Alert, Button } from '@mui/material';
import { Check } from '@mui/icons-material';

import { setTenantUpdatesModerated } from '@api-admin/tenant-updates';
import toast from '@utils/toast';
import { formatDateTime } from '@utils/parsing';
import formatTenantUpdateSources from '@utils/tenantUpdates';

type PropsType = {
    tenantId: number,
    updatedAt: string,
    updatedByName: string | null,
    sources: string[] | null,
    onModerated: () => void
};

export default function TenantUpdateBanner(props: PropsType) {
    const {
        tenantId,
        updatedAt,
        updatedByName,
        sources,
        onModerated
    } = props;

    const [busy, setBusy] = React.useState(false);
    const sourcesLabel = formatTenantUpdateSources(sources);

    const onMarkAsModerated = React.useCallback(async () => {
        setBusy(true);
        try {
            await setTenantUpdatesModerated(tenantId);
            toast('Uppdateringen markerad som hanterad', undefined, true);
            onModerated();
        } catch (e) {
            toast(e, 'Kunde inte markera uppdateringen som hanterad');
        } finally {
            setBusy(false);
        }
    }, [tenantId, onModerated]);

    return (
        <Alert
            severity="info"
            sx={{ mb: 2, alignItems: 'center' }}
            action={(
                <Button
                    variant="outlined"
                    size="small"
                    disabled={busy}
                    color="info"
                    startIcon={<Check />}
                    onClick={onMarkAsModerated}
                >
                    Markera som kontrollerad
                </Button>
            )}
        >
            {`Uppdaterades ${formatDateTime(updatedAt)} av ${updatedByName || 'okänd'}`}
            {sourcesLabel && ` – ${sourcesLabel}`}
        </Alert>
    );
}
